import React, { useState } from 'react'
import { useGetCategoriesQuery } from '../features/categories/categoriesApiSlice';

const FilterBar = ({ need, changeNeed, data, isSuccess, onCategorySelect }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleCategoryClick = (category) => {
    console.log('Category clicked:', category);
    if (category === 'all') {
      setSelectedCategory(null);
      onCategorySelect({ category: null, all: "true" });
    } else {
      setSelectedCategory(category._id);
      onCategorySelect({ category: category._id, all: "false" });
    }
  };

  return (
    <div className='w-full fixed top-[56px] z-40 right-0 left-0 text-[.9rem] py-[2px] dark:text-white flex items-center gap-3 bg-blue-50 dark:bg-neutral-700 shadow-lg px-[5%] select-none'>
      <div className='flex items-end leading-none gap-[4px] px-2'>
        <h1 className={`bg-whited border-r border-white text-center h-full cursor-pointer ${need === "Sell" ? "underline text-black":"text-neutral-500"}`} onClick={changeNeed}>Offer</h1>
        <div className='w-[1px] h-[15px] bg-gray-300'/>
        <h1 className={`bg-whited border-r border-white text-center h-full cursor-pointer ${need !== "Sell" ? "underline text-black":"text-neutral-500"}`} onClick={changeNeed}>Request</h1>
      </div>
      <div className='flex flex-grow flex-nowrap overflow-x-scroll dark:bg-neutral-600 p-1 gap-2' style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}>
        <span 
          onClick={() => handleCategoryClick('all')}
          className={`cursor-pointer w-auto whitespace-nowrap border px-2 py-1 rounded-full transition-all duration-200 ${
            selectedCategory === null 
              ? 'border-blue-500 bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-100' 
              : 'border-transparent hover:border-neutral-500'
          }`}
        >
          All
        </span>
        {data?.map((category) => {
          return category ? (
            <span 
              key={category._id}
              onClick={() => handleCategoryClick(category)}
              className={`cursor-pointer w-auto whitespace-nowrap border px-2 py-1 rounded-full transition-all duration-200 ${
                selectedCategory === category._id 
                  ? 'border-blue-500 bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-100' 
                  : 'border-transparent hover:border-neutral-500'
              }`}
            >
              {category.name}
            </span>
          ) : null;
        })}
      </div>
    </div>
  )
}

export default FilterBar;